import api from '@/api/api'

const state = {
  id: null,
  email: null,
  first_name: null,
  last_name: null,
  role: null,
}

const mutations = {
  GET_USER: (state, data) => {
    state.id = data.id
    state.email = data.email
    state.first_name = data.first_name
    state.last_name = data.last_name
    state.role = data.role
  },
  CLEAR_USER: state => {
    state.id = null
    state.email = null
    state.first_name = null
    state.last_name = null
    state.role = null
  },
}

const actions = {
  loadUser: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      api
        .getUser()
        .then(async response => {
          commit('GET_USER', response.data)
          await dispatch('favourites/loadFavourites', null, { root: true })
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  clearUserData: ({ commit }) => {
    commit('CLEAR_USER')
  },
}

const getters = {
  userId: state => {
    return state.id
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
